module.exports = __webpack_public_path__ + "productivityIco.webp?bfb0e7fb3a4d836ad3e5ece3f63afa3e";